'use client';
import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { useInheritDocDirection, cn } from "@tameeni/shared-logic";
const ScrollArea = React.forwardRef(
  ({
    className,
    children,
    dir,
    disabled,
    locale,
    scrollbarProps = {},
    ...props
  }, ref) => {
    const { direction } = useInheritDocDirection({ locale });
    return /* @__PURE__ */ jsxs(
      ScrollAreaPrimitive.Root,
      {
        ref,
        className: cn({ "overflow-hidden": !disabled }, className),
        dir: dir || direction,
        "aria-disabled": disabled ? "true" : "false",
        ...props,
        children: [
          /* @__PURE__ */ jsx(ScrollAreaPrimitive.Viewport, { className: "h-full w-full rounded-[inherit]", children }),
          !disabled && /* @__PURE__ */ jsx(ScrollBar, { ...scrollbarProps }),
          /* @__PURE__ */ jsx(ScrollAreaPrimitive.Corner, {})
        ]
      }
    );
  }
);
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
const ScrollBar = React.forwardRef(({ className, orientation = "vertical", ...props }, ref) => /* @__PURE__ */ jsx(
  ScrollAreaPrimitive.ScrollAreaScrollbar,
  {
    ref,
    orientation,
    className: cn(
      "flex touch-none select-none transition-colors opacity-20",
      orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ScrollAreaPrimitive.ScrollAreaThumb, { className: " flex-1 rounded-full bg-border" })
  }
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export {
  ScrollArea,
  ScrollBar
};
